import { fromZonedTime } from "date-fns-tz";
import { format } from "date-fns";

const DATABASE_TIME_ZONE = "America/Denver";

export function parseDatabaseDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  // Support responses from older backend versions that did not include an offset.
  return /(?:Z|[+-]\d{2}:?\d{2})$/i.test(String(value))
    ? date
    : fromZonedTime(String(value), DATABASE_TIME_ZONE);
}

export function parseUtcDate(value) {
  if (!value) return null;
  const stringValue = String(value);
  const hasOffset = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(stringValue);
  const date = new Date(hasOffset ? stringValue : `${stringValue}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatLocalDateTimeWithZone(date) {
  if (!date) return "—";
  const timeZoneName = new Intl.DateTimeFormat(undefined, {
    timeZoneName: "short",
  })
    .formatToParts(date)
    .find((part) => part.type === "timeZoneName")?.value;

  return `${format(date, "yyyy-MM-dd HH:mm:ss")} ${timeZoneName || ""}`.trim();
}

export function formatLocalDateTime(date, includeSeconds = false) {
  return date
    ? new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        ...(includeSeconds ? { second: "2-digit" } : {}),
        timeZoneName: "short",
      }).format(date)
    : null;
}

export function formatRelativeTime(date, now = new Date()) {
  if (!date) return null;

  const diffMs = now.getTime() - date.getTime();
  if (diffMs < 60 * 1000) return "Just now";

  const minutes = Math.floor(diffMs / (60 * 1000));
  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  return `${days}d ${remainingHours}h ago`;
}
